import { Frame } from '@shopify/polaris'
import type { ReactNode } from 'react'
import { TopNav } from './TopNav'
import { AppBridgeNavMenu } from './AppBridgeNavMenu'

interface AppLayoutProps {
  children: ReactNode
}

export function AppLayout({ children }: AppLayoutProps) {
  return (
    <Frame>
      <AppBridgeNavMenu />
      <div className="flex h-screen w-full flex-col bg-bg font-sans text-text-primary">
        <TopNav />
        <main className="flex-1 overflow-y-auto">
          <div className="mx-auto w-full max-w-[1600px] px-4 py-5 sm:px-5 lg:px-6">
            {children}
          </div>
        </main>
      </div>
    </Frame>
  )
}
